module.exports = __webpack_public_path__ + "img/ufa-qr.6e446fde.png";